import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { RfidCard } from '../../../models/rfidCard';
import { RfidCardsService } from '../../../services/entity/rfidCards.service';


@Component({
  selector: 'app-delete-rfid-card-for-customer-dialog-content',
  templateUrl: './delete-rfid-card-for-customer-dialog-content.component.html',
  styleUrls: ['./delete-rfid-card-for-customer-dialog-content.component.scss'],
  providers: [FormService]
})
export class DeleteRFIDCardForCustomerDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DeleteRFIDCardForCustomerDialogContentComponent';

  public form: UntypedFormGroup;
  @Input() private rfidCard: RfidCard;
 

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private rfidCardsService: RfidCardsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formService.form = new UntypedFormGroup({
    });
  }

  onSubmit(formValue) {
    this.rfidCardsService.deleteEntity(this.rfidCard.id).subscribe(result => {
      this.activeModal.close();
    }, error => {
        this.messageService.setError(error);
    });
  }
}
